module.exports = __webpack_public_path__ + "8f62950a69100e12306b7f403d188468.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/phone.png
// module id = DFKo
// module chunks = 3